// Dependencies
import React, { FunctionComponent, ReactNode } from "react";

// Styles
import { Container } from "./styles";

// Types
type WebpRadioGroupProps = {
    contentGroup: ReactNode;
};

export const WebpRadioGroup: FunctionComponent<WebpRadioGroupProps> = ({ contentGroup }) => {
    return <Container>{contentGroup}</Container>;
};
